import React, { useState, useEffect } from 'react';
import api from '../api';
import { FaQuestionCircle, FaChevronDown, FaChevronUp } from 'react-icons/fa';

const FAQ = () => {
  const [faqs, setFaqs] = useState([]);
  const [activeIndex, setActiveIndex] = useState(null);
  


  useEffect(() => {
   api.get('/FAQ').then(res => setFaqs(res.data)).catch(console.error);
  }, []);

  const toggleFAQ = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <section className="faq-section py-5 bg-light" id="faq">
      <div className="container">
        
        {/* Header */}
        <div className="text-center mb-5">
          <span className="badge bg-primary mb-3 px-3 py-2">
            <FaQuestionCircle className="me-2" /> FAQs
          </span>
          <h2 className="display-5 fw-bold text-dark mb-3">Frequently Asked Questions</h2>
          <p className="lead text-muted">Get answers to common solar queries</p>
        </div>

        <div className="row">
          <div className="col-lg-10 mx-auto">
            <div className="faq-list">
              {faqs.map((faq, index) => (
                <div key={faq.id} className="faq-item card border-0 shadow-sm mb-3" style={{ transition: 'all 0.3s ease', overflow: 'hidden' }}>
                  <div 
                    className="faq-question card-body p-4 d-flex justify-content-between align-items-center"
                    onClick={() => toggleFAQ(index)}
                    style={{ cursor: 'pointer', background: activeIndex === index ? 'linear-gradient(135deg, #E8F8F3 0%, #E3F2FD 100%)' : '#ffffff' }}
                  >
                    <h5 className="mb-0 fw-bold" style={{ color: activeIndex === index ? '#00D084' : '#1B3F6E', fontSize: '1.1rem', flex: 1 }}>
                      <span className="me-3" style={{ color: '#00D084' }}>Q{index + 1}.</span> {faq.question}
                    </h5>
                    <div className="faq-icon-wrapper ms-3" style={{ width: '40px', height: '40px', borderRadius: '50%', background: activeIndex === index ? 'linear-gradient(135deg, #00D084 0%, #00A86B 100%)' : '#F8F9FA', display: 'flex', alignItems: 'center', justifyContent: 'center', transition: 'all 0.3s ease' }}>
                      {activeIndex === index ? <FaChevronUp style={{ color: '#ffffff' }} /> : <FaChevronDown style={{ color: '#1B3F6E' }} />}
                    </div>
                  </div>
                  
                  {activeIndex === index && (
                    <div className="faq-answer card-body pt-0 pb-4 px-4" style={{ animation: 'fadeIn 0.3s ease', background: 'linear-gradient(135deg, #E8F8F3 0%, #E3F2FD 100%)' }}>
                      <div className="ps-5" style={{ borderLeft: '3px solid #00D084', paddingLeft: '1.5rem' }}>
                        <p className="mb-0 text-muted" style={{ lineHeight: '1.8' }}>
                          <strong style={{ color: '#1B3F6E' }}>Answer: </strong> {faq.answer}
                        </p>
                      </div>
                    </div>
                  )}
                </div>
              ))}
            </div>

            {/* CTA */}
            <div className="mt-5">
              <div className="card border-0 shadow-lg text-center p-4" style={{ background: 'linear-gradient(135deg, #1B3F6E 0%, #2E5C8A 100%)' }}>
                <div className="card-body">
                  <h4 className="text-white fw-bold mb-3"><FaQuestionCircle className="me-2" /> Still Have Questions?</h4>
                  <p className="text-white mb-4 opacity-90">Talk to our NIT & DTU engineer team for personalized answers</p>
                  <div className="d-flex gap-3 justify-content-center flex-wrap">
                    <a href="#contact" className="btn btn-light btn-lg rounded-pill px-5 fw-bold" style={{ color: '#1B3F6E' }}><i className="bi bi-telephone-fill me-2"></i> Call: +91-9031654981</a>
                    <a href="https://wa.me/919031654981" target="_blank" rel="noopener noreferrer" className="btn btn-success btn-lg rounded-pill px-5 fw-bold" style={{ background: '#25D366', border: 'none' }}><i className="bi bi-whatsapp me-2"></i> WhatsApp Us</a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <style jsx>{` @keyframes fadeIn { from { opacity: 0; transform: translateY(-10px); } to { opacity: 1; transform: translateY(0); } } .faq-item:hover { transform: translateY(-3px); box-shadow: 0 10px 30px rgba(0, 0, 0, 0.12) !important; } `}</style>
    </section>
  );
};

export default FAQ;